module.exports = __webpack_public_path__ + "static/img/header_bj.cce72f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/support/header_bj.png
// module id = YoWR
// module chunks = 1